export default "__VITE_ASSET__f152b5bc__"